import { PPDWidgetStoresList } from "../PPDWidgetStoresList";
import { PPDWidgetStoresTable } from "../PPDWidgetStoresTable";
import { PPDModal } from '../../../PPDModal';
import { useMedia } from 'shared/hooks';
import { UserDashboardWidgetModel } from 'shared/models';
import { PPDWidgetGroupSelect } from '../PPDWidgetGroupSelect';

import "./styles.scss"
import { EntityId } from 'shared/models/UserDashboardModel.ts';
import { observer } from 'mobx-react';

type Props = {
    title?: string;
    isOpen: boolean;
    onClose: () => void;
    items: UserDashboardWidgetModel['items'];
    labels: UserDashboardWidgetModel['labels'];
    onSelect: (row: any) => void;
    groups: UserDashboardWidgetModel['groups'];
    groupId: EntityId | null;
    onChangeGroup: (groupId: string | number) => void;
    stickyHeader?: boolean;
};

export const PPDWidgetStoresModal = observer(({
    title,
    isOpen,
    onClose,
    items,
    labels,
    onSelect,
    groups,
    groupId,
    onChangeGroup,
    stickyHeader = false,
}: Props) => {
    const { isMobileOrTablet } = useMedia()

    return (
        <PPDModal isOpened={isOpen} onClose={onClose} className="ppd-widget-stores-modal">
            <div className="ppd-widget-stores-modal__header">
                {
                    title && (
                        <div className="ppd-widget-stores-modal__title">
                            {title}
                        </div>
                    )
                }

                {groups.length > 0 && (
                    <div className="ppd-widget-stores-modal__groups">
                        <PPDWidgetGroupSelect
                            items={groups}
                            value={groupId}
                            onChange={onChangeGroup}
                        />
                    </div>
                )}
            </div>
            <div className="ppd-widget-stores-modal__content">
                {isMobileOrTablet ? (
                    <PPDWidgetStoresList
                        items={items}
                        onSelect={onSelect}
                    />
                ) : (
                    <PPDWidgetStoresTable
                        items={items}
                        labels={labels}
                        stickyHeader={stickyHeader}
                        className="ppd-widget-stores-modal__table"
                    />
                )}
            </div>
        </PPDModal>
    );
});
